import { Switch as ASwitch } from "ant-design-vue"

export default {
  props: {
    ...ASwitch.props,
    checkdValue: {
      type: [String, Number, Boolean],
      default: '1'
    },
    value: [String, Number, Boolean],
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    event: 'change'
  },
  data() {
    return {

    }
  },
  methods: {
    getCorrectValue(checked) {
      if (checked) {
        return this.checkdValue
      }
      const type = typeof(this.checkdValue)
      if (type === 'string') {
        return '0'
      }
      if (type === 'number') {
        return 0
      }
      if (type === 'boolean') {
        return false
      }
      return false
    },
    onChange(checked) {
      const v = this.getCorrectValue(checked)
      this.$emit('change', v)
    }
  },
  render(h) {
    const props = []
    const keys = Object.keys(ASwitch.props)
    keys.forEach(k => {
      if (this[k] === undefined) {
        return
      }
      this[k] && (props[k] = this[k])
    })
    props.checked = this.value === this.checkdValue
    props.disabled = this.disabled
    return h('a-switch', {
      props: {
        ...props,
      },
      on: {
        change: (v) => {
          this.onChange(v)
        }
      }
    })
  },
}